<template>
<div>
  <h3 class="text-center mt-3 mb-4">Self registration</h3>

  <div class="row">
    <div class="col-9 offset-1">
      <b-form-group label-cols="3" label="Name" label-for="name" label-align-sm="right">
        <b-form-input id="name" v-model.trim="registration.name" :state="errorStates.name" aria-describedby="name-input-feedback" @keydown.native.enter="register"></b-form-input>
        <b-form-invalid-feedback id="name-input-feedback" class="text-right">{{errors.name}}</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-cols="3" label="Surname" label-for="surname" label-align-sm="right">
        <b-form-input id="surname" v-model.trim="registration.surname" :state="errorStates.surname" aria-describedby="surname-input-feedback" @keydown.native.enter="register"></b-form-input>
        <b-form-invalid-feedback id="surname-input-feedback" class="text-right">{{errors.surname}}</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-cols="3" label="Email" label-for="email" label-align-sm="right">
        <b-form-input id="email" v-model.trim="registration.email" :state="errorStates.email" aria-describedby="email-input-feedback" @keydown.native.enter="register"></b-form-input>
        <b-form-invalid-feedback id="email-input-feedback" class="text-right">{{errors.email}}</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-cols="3" label="Institution" label-for="institution" label-align-sm="right">
        <b-form-input id="institution" v-model.trim="registration.institution" :state="errorStates.institution" aria-describedby="institution-input-feedback" @keydown.native.enter="register"></b-form-input>
        <b-form-invalid-feedback id="institution-input-feedback" class="text-right">{{errors.institution}}</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-cols="3" label="Password" label-for="password" label-align-sm="right">
        <b-form-input id="password" v-model="registration.password" type="password" :state="errorStates.password" aria-describedby="password-input-feedback" @keydown.native.enter="register"></b-form-input>
        <b-form-invalid-feedback id="password-input-feedback" class="text-right">{{errors.password}}</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-cols="3" label="Confirm Password" label-for="confirmPassword" label-align-sm="right">
        <b-form-input id="confirmPassword" v-model="registration.confirmPassword" type="password" :state="errorStates.confirmPassword" aria-describedby="confirmPassword-input-feedback" @keydown.native.enter="register"></b-form-input>
        <b-form-invalid-feedback id="confirmPassword-input-feedback" class="text-right">{{errors.confirmPassword}}</b-form-invalid-feedback>
      </b-form-group>
      <div class="row ml-2 mt-4">
        <div class="offset-3">
          <p><strong>For using IA2 services you need to accept our <a href="https://sso.ia2.inaf.it/home/privacy.php?lang=en" target="_blank">privacy policy</a>.</strong></p>
          <b-form-checkbox id="tou-accepted" v-model="registration.touAccepted" @keydown.native.enter="register">
            I accept the terms and use
          </b-form-checkbox>
          <b-button variant="primary" class="mt-3" :disabled="!registration.touAccepted" @click="register">Register</b-button>
        </div>
      </div>
    </div>
  </div>
  <ConfirmDuplicateModal />
</div>
</template>

<script>
import { mapState } from 'vuex';
import ConfirmDuplicateModal from './ConfirmDuplicateModal.vue';

export default {
  name: 'Register',
  components: {
    ConfirmDuplicateModal
  },
  computed: mapState({
    registration: state => state.registration,
    errors: state => state.registrationErrors,
    errorStates: state => {
      let map = {};
      for (const key of Object.keys(state.registrationErrors)) {
        if (state.registrationErrors[key]) {
          map[key] = false;
        } else {
          map[key] = null;
        }
      }
      return map;
    }
  }),
  methods: {
    register() {
      if (this.registration.touAccepted) {
        this.$store.dispatch('register', this.$bvModal);
      }
    }
  }
}
</script>
